import apiService from './apiService';

class TrackingService {
  async getTrackingData(tripId) {
    try {

      const endpoint = `/api/v1/trips/trips/${tripId}/tracking-data`;
      const response = await apiService.get(endpoint);
      return response;
    } catch (error) {
      throw error;
    }
  }
}

export default new TrackingService();